import http from './http';

export default {
  get(url) {
    return http().get(url);
  },
}
